import { useLocation, matchRoutes } from 'react-router';

import { APP_ROUTES } from '../route';

// React Router v5 handed components `match.path` -- the route *pattern* that
// matched, e.g. '/home/therapy-plans/:id'. v6 exposes no equivalent outside a
// data router, so recover it by matching the current pathname against
// APP_ROUTES with the router's own ranking (static segments beat dynamic ones).
const ROUTE_OBJECTS = Object.values(APP_ROUTES).map(path => ({ path }));

export const useRoutePattern = () => {
  const { pathname } = useLocation();
  const matches = matchRoutes(ROUTE_OBJECTS, pathname);
  return matches?.[0]?.route?.path || pathname;
};

export default useRoutePattern;
